export default "__VITE_ASSET__B09$HCB4__"